import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import LOGO from "../../Img/logo.png"


const LoadingPage = () => {
  const [progress, setProgress] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  const [loadingComplete, setLoadingComplete] = useState(false);
  const navigate = useNavigate();


  const loadingSteps = [
    { icon: "📀", text: "PRI wise Available Find", delay: 1000 },
    { icon: "🛡️", text: "Voucher Entry Status", delay: 1500 },
    { icon: "📊", text: "Cash Analysis Report", delay: 1000 },
    { icon: "📈", text: "Activity Query", delay: 1500 },
    { icon: "✅", text: "Activity wise Estimation & Expenditure", delay: 1500 },
    { icon: "📀", text: "Activity Details", delay: 1000 }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          setLoadingComplete(true);
          clearInterval(timer);
          // Auto redirect after 1 second when loading is complete
          setTimeout(() => {
            // Here you would typically use router.push('/dashboard') or similar
             navigate("/dashboard");
          }, 1000);
          return 100;
        }
        return prev + 2;
      });
    }, 60);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const stepTimer = setInterval(() => {
      setCurrentStep(prev => {
        if (prev >= loadingSteps.length - 1) {
          clearInterval(stepTimer);
          return prev;
        }
        return prev + 1;
      });
    }, 700);

    return () => clearInterval(stepTimer);
  }, [loadingSteps.length]);

  const FloatingOrb = ({ size, position, color, delay }) => (
    <div 
      className={`absolute ${size} ${color} rounded-full opacity-20 animate-pulse`}
      style={{
        ...position,
        animationDelay: `${delay}s`,
        filter: 'blur(1px)'
      }}
    />
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-teal-900 to-slate-800 flex items-center justify-center p-4 overflow-hidden relative">
      
      {/* Custom Styles */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
          
          * {
            font-family: 'Inter', sans-serif;
          }
          
          .logo-font {
            font-family: 'Space Grotesk', sans-serif;
          }
          
          @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(0deg); }
            50% { transform: translateY(-10px) rotate(5deg); }
          }
          
          @keyframes spin-slow {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          
          @keyframes pulse-glow {
            0%, 100% { box-shadow: 0 0 20px rgba(20, 184, 166, 0.3); }
            50% { box-shadow: 0 0 40px rgba(20, 184, 166, 0.8); }
          }
          
          @keyframes slide-up {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes fadeOut {
            from {
              opacity: 1;
            }
            to {
              opacity: 0;
            }
          }
          
          .float-animation {
            animation: float 3s ease-in-out infinite;
          }
          
          .spin-slow {
            animation: spin-slow 8s linear infinite;
          }
          
          .pulse-glow {
            animation: pulse-glow 2s ease-in-out infinite;
          }
          
          .slide-up {
            animation: slide-up 0.6s ease-out forwards;
          }
          
          .fade-out {
            animation: fadeOut 1s ease-out forwards;
          }
          
          .gradient-text {
            background: linear-gradient(135deg, #14b8a6, #06b6d4, #3b82f6);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
          
          .glass-effect {
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(20px);
            border: 1px solid rgba(255, 255, 255, 0.2);
          }
        `
      }} />

      {/* Floating Background Orbs */}
      <FloatingOrb 
        size="w-32 h-32 sm:w-48 sm:h-48" 
        position={{ top: '10%', left: '80%' }} 
        color="bg-teal-500" 
        delay={0} 
      />
      <FloatingOrb 
        size="w-24 h-24 sm:w-36 sm:h-36" 
        position={{ bottom: '20%', left: '10%' }} 
        color="bg-blue-500" 
        delay={1} 
      />
      <FloatingOrb 
        size="w-20 h-20 sm:w-28 sm:h-28" 
        position={{ top: '60%', right: '15%' }} 
        color="bg-cyan-500" 
        delay={2} 
      />

      {/* Main Loading Container */}
      <div className={`w-full max-w-md mx-auto text-center transition-all duration-1000 ${loadingComplete ? 'fade-out' : ''}`}>
        
        {/* Logo Section */}
        <div className="mb-8 sm:mb-12">
            <div className="relative inline-block">
            {/* Rotating Border */}
            <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-teal-400 border-r-blue-400 spin-slow"></div>
            
            {/* Logo Container */}
            <div className="relative w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 bg-white-to-br from-teal-500 to-blue-900 rounded-full flex items-center justify-center pulse-glow">
              {/* Replace the src below with your logo path */}
              <img
              src={LOGO} // Direct path to public folder
              alt="Logo"
              className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 object-contain float-animation"
              />
            </div>
            </div>
          
          {/* Brand Name */}
          <div className="mt-6">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold logo-font text-white mb-2">
             SAHAJ-SARAL MIS
            </h1>
            <p className="text-sm sm:text-base md:text-lg gradient-text font-semibold">
             IT & Statistical Cell P&RD Department
            </p>
          </div>
        </div>

        {/* Loading Progress Section */}
        <div className="glass-effect rounded-2xl p-6 sm:p-8 mb-8">
          {/* Progress Bar */}
          <div className="mb-6">
            <div className="flex justify-between items-center mb-3">
              <span className="text-xs sm:text-sm text-gray-300">Loading Progress</span>
              <span className="text-xs sm:text-sm font-bold text-teal-400">{progress}%</span>
            </div>
            
            <div className="w-full bg-gray-700 rounded-full h-2 sm:h-3 overflow-hidden">
              <div 
                className="h-full bg-gradient-to-r from-teal-500 to-blue-500 rounded-full transition-all duration-300 ease-out relative"
                style={{ width: `${progress}%` }}
              >
                <div className="absolute inset-0 bg-white/20 animate-pulse rounded-full"></div>
              </div>
            </div>
          </div>

          {/* Loading Steps */}
          <div className="space-y-3 sm:space-y-4">
            {loadingSteps.map((step, index) => {
              const isActive = index === currentStep;
              const isCompleted = index < currentStep;
              
              return (
                <div 
                  key={index}
                  className={`flex items-center space-x-3 sm:space-x-4 transition-all duration-500 ${
                    isActive ? 'text-teal-400 scale-105' : 
                    isCompleted ? 'text-green-400' : 'text-gray-500'
                  }`}
                >
                  <div className={`flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center transition-all duration-500 ${
                    isActive ? 'bg-teal-500/20 border-2 border-teal-400' :
                    isCompleted ? 'bg-green-500/20 border-2 border-green-400' :
                    'bg-gray-700 border border-gray-600'
                  }`}>
                    <span className={`text-lg sm:text-xl ${
                      isActive ? 'animate-pulse' : ''
                    }`}>
                      {step.icon}
                    </span>
                  </div>
                  
                  <span className={`text-sm sm:text-base font-medium transition-all duration-500 ${
                    isActive ? 'font-semibold' : ''
                  }`}>
                    {step.text}
                  </span>
                  
                  {isActive && (
                    <div className="flex space-x-1">
                      <div className="w-1 h-1 bg-teal-400 rounded-full animate-bounce"></div>
                      <div className="w-1 h-1 bg-teal-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                      <div className="w-1 h-1 bg-teal-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                    </div>
                  )}
                  
                  {isCompleted && (
                    <span className="text-green-400 animate-pulse text-sm">✓</span>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Status Message */}
        <div className="slide-up">
          <p className="text-xs sm:text-sm text-gray-400 mb-2">
            {loadingComplete ? 'Loading complete! Redirecting...' : 'Initializing secure connection...'}
          </p>
          <div className="flex justify-center space-x-2">
            <div className="w-2 h-2 bg-teal-400 rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-teal-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-2 h-2 bg-teal-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
        </div>
      </div> 

      {/* Footer Info */}
      <div className="absolute bottom-4 left-4 right-4 text-center">
        <p className="text-xs text-gray-500">
          © 2024 IT And Statistical Cell, Panchayat & Rural Development Department
        </p>
        <p className="text-xs text-gray-600 mt-1">
          Government of West Bengal
        </p>
      </div>
    </div>
  );
};

export default LoadingPage;